import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromProfile from './profile.reducers';

export interface ProfileState {
  stateData: fromProfile.State;
}

export interface State extends fromRoot.AppState {
  profile: ProfileState;
}

export const reducers = {
  stateData: fromProfile.reducer
};

export const selectProfileState = createFeatureSelector<ProfileState>('profile');

export const selectProfileStateData = createSelector(selectProfileState, (state: ProfileState) => state.stateData);

export const getProfileState = createSelector(selectProfileStateData, fromProfile.getStateData);

export const getSuccessMessage = createSelector(selectProfileStateData, fromProfile.getSuccessMessage);

export const getProfileScreenError = createSelector(selectProfileStateData, fromProfile.getError);

export const getProfileScreenPending = createSelector(selectProfileStateData, fromProfile.getPending);